import i18n from "../i18n";

/**
 * Locale candidates for Intl date/number formatting.
 *
 * Formatting follows the language the user selected in the app, carrying the
 * device's region so regional conventions survive: a German speaker sees
 * 16:40 wherever they are, while English follows the device — 16:40 in the
 * UK, 4:40 PM in the US. Bare language tags alone would silently apply
 * en-US conventions to UK users, which is why the region is grafted on.
 */
export function formattingLocales(): string[] {
    const language = (i18n.resolvedLanguage ?? i18n.language ?? "en").split("-")[0];
    const deviceLocale = navigator.language || navigator.languages?.[0];

    let region: string | undefined;
    try {
        region = deviceLocale ? new Intl.Locale(deviceLocale).region : undefined;
    } catch {
        // Malformed device locale; fall back to the bare language.
    }

    return region ? [`${language}-${region}`, language] : [language];
}
